import React from 'react'

export const ChannelIcon = () => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 0L0 2.90909V7.27273C0 11.3091 2.77333 15.0836 6.5 16C10.2267 15.0836 13 11.3091 13 7.27273V2.90909L6.5 0ZM6.5 7.99273H11.5556C11.1728 10.9891 9.18667 13.6582 6.5 14.4945V8H1.44444V3.85455L6.5 1.59273V7.99273Z"
      fill="#6B6B6B"
    />
  </svg>
)
